import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Supplier'

  }
];

@Component({
  selector: 'page-supplier',
  templateUrl: './supplier.html',
  styleUrls: ['./supplier.scss']
})

export class PageSupplier implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  ctrl: FormControl;
  filtered: any;



  rows = [];
  temp = [];
  print = "";
  selected = [];

  suppliers = [];
  key: any;
  fetchSupplier = [];
  loadingIndicator: boolean = true;

  //diaglog
  dialogRef: MdDialogRef<SupplierDisableDialog>;
  selectedOption: string;
  sysPathPrint: String = environment.sysPath + "/api/supplier-list-print.php";
  sysPathExport: String = environment.sysPath + "/api/supplier-list-export.php";
  constructor(private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
    this.getSupplier();
    this.getDataStart();
    this._sharedService.emitChange(this.pageTitle);
  }

  getDataStart() {
    this.httpservice.fetchget('getJSON_supplier.php?', data => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
    })
  }

  getSupplier() {
    this.httpservice.fetchget('getJSON_supplier_name.php?', data => {
      this.suppliers = data;
    })
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        console.log('------val------', this.key);
        return val ? this.suppliers.filter((s) => new RegExp(val, 'gi').test(s.tb2_company_shortname)) : this.suppliers;
      });
  }

  disableSupplier(tb2_id: string) {
    this.httpservice.fetchget('disableSupplier.php?tb2_id=' + tb2_id, data => {
      this.getDataStart();
    })
  }
  edit(tb2_id: string) {
    this.router.navigateByUrl('default-layout/supplier-form-edit/' + tb2_id);
  }


  //check box

  onSelect({ selected }) {
    console.log('Select Event', this.selected);
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  onActivate(event) {
    console.log('Activate Event', event);
  }

  add() {
    this.selected.push(this.rows[1], this.rows[3]);
  }

  update() {
    this.selected = [this.rows[1], this.rows[3]];
  }

  remove() {
    this.selected = [];
  }

  //post data
  openPrint() {
    for (let i = 0; i < this.selected.length; i++) {
      console.log('----select---', this.selected[i]['tb2_id']);
      if (this.selected[i]['tb2_id'] != "undefined") {
        this.print += "&print[]=" + this.selected[i]['tb2_id'];
      }
    }
    let popupWinindow
    popupWinindow = window.open(environment.url + '/api/print-supplier-qr.php?' + this.print, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
    this.selected = [];
    this.print = "";
  }

  search() {
    this.httpservice.fetchget('getJSON_supplier.php?key=' + this.key, data => {
      this.rows = data;
    });
  }

  ngOnInit() { }
  openDialog(tb2_id: string) {
    let dialogRef = this.dialog.open(SupplierDisableDialog);
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
        this.disableSupplier(tb2_id);
      } else {
        console.log('---result---', result);
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value;
    const temp = this.temp.filter(function (d) {
      return d.tb2_company_shortname.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.rows = temp;
  }
}
//dialog
@Component({
  selector: 'supplier-dialog',
  templateUrl: 'supplier-dialog.html',
})
export class SupplierDisableDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<SupplierDisableDialog>) { }
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/supplier/supplier.ts